<template>
  <svg width="117" height="36" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 187.92">
    <title>gemini_logo-full</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          fill="#076eff"
          d="M125.94,126.64q0,26.1-15.48,41.57-17.4,18.45-45.75,18.44-27.13,0-45.92-18.78T0,121.6Q0,94.1,18.79,75.33T64.71,56.54a69.1,69.1,0,0,1,25.92,4.87,51.94,51.94,0,0,1,20,13.74L99.15,86.63A38.58,38.58,0,0,0,84.28,75.76a49.14,49.14,0,0,0-19.57-3.91q-20.35,0-34.44,14.09Q16.35,100.21,16.35,121.6t13.92,35.66q14.08,14.09,34.44,14.09,18.62,0,31-10.44t14.27-28.7H64.71v-15h60.36A53.36,53.36,0,0,1,125.94,126.64Z"
        />
        <path
          fill="#076eff"
          d="M176.17,96.21q19.16,0,30.49,12.38T218,143.29l-.18,1.76H150.17q.35,12.66,8.43,20.38a27,27,0,0,0,19.33,7.73q15.47,0,24.24-15.46l14.41,7a42.92,42.92,0,0,1-16.07,17,44.51,44.51,0,0,1-23.29,6.15q-19,0-31.27-13t-12.3-32.86q0-19.67,11.95-32.76T176.17,96.21ZM175.82,111a23.46,23.46,0,0,0-15.73,5.63,26.82,26.82,0,0,0-8.69,15.11h49.37a21.44,21.44,0,0,0-7.29-14.85Q186.88,111,175.82,111Z"
        />
        <path
          fill="#076eff"
          d="M244.49,184.84H228.38V99h15.41v11.91h.7a28.72,28.72,0,0,1,11.3-10.51,31.61,31.61,0,0,1,31.8.17,25.88,25.88,0,0,1,10.51,12.09q10.68-16.47,29.6-16.46,14.9,0,22.95,9.1t8.06,25.93v53.6H342.59V133.69q0-12.09-4.38-17.43t-14.71-5.34q-9.28,0-15.59,7.88a28.82,28.82,0,0,0-6.31,18.57v47.47H285.48V133.69q0-12.09-4.38-17.43t-14.71-5.34q-9.28,0-15.59,7.88a28.88,28.88,0,0,0-6.31,18.57Z"
        />
        <path
          fill="#076eff"
          d="M393.26,69.22a11.37,11.37,0,1,1-3.33-8.08A11,11,0,0,1,393.26,69.22Zm-3.33,29.65v86H373.79v-86Z"
        />
        <path
          fill="#076eff"
          d="M512,69.22a11.37,11.37,0,1,1-3.33-8.08A11,11,0,0,1,512,69.22Zm-3.33,29.65v86H492.52v-86Z"
        />
        <path
          fill="#076eff"
          d="M404,99h15.42v11.91h.7a28.65,28.65,0,0,1,11.3-10.51,32.4,32.4,0,0,1,15.85-4.2q15.76,0,24.26,9t8.5,25.66v54H463.91v-52.9q-.53-21-21.19-21a20.15,20.15,0,0,0-16.12,7.79,28.26,28.26,0,0,0-6.48,18.66v47.47H404Z"
        />
        <path
          fill="#076eff"
          d="M348.37,72.76h0A43.36,43.36,0,0,0,312,36.38h0A43.36,43.36,0,0,0,348.37,0h0a43.38,43.38,0,0,0,36.38,36.38h0A43.38,43.38,0,0,0,348.37,72.76Z"
        />
      </g>
    </g>
  </svg>
</template>
